// extracted by mini-css-extract-plugin
module.exports = {"loginButton":"LoginButton_loginButton__EwWDC","icon":"LoginButton_icon__HkFLg"};